<template>
  <v-row justify="center">
    <v-dialog
      v-model="deleteMetadataDialogState"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Suppression de metadonnées</span>
        </v-card-title>
        <v-container>
          <v-card-text>
            <p v-if="successMessage">
              <v-alert
                text
                dense
                color="teal"
                border="left"
                type="success"
              >
                {{ successMessage }}
              </v-alert>
            </p>

            <span v-if="metadata">Etes-vous sûr de vouloir supprimer les metadonnées ?</span>
          </v-card-text>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDeleteMetadataDialog(false)"
          >
            Annuler
          </v-btn>

          <button
            type="button"
            :disabled="loading"
            class="v-btn v-btn--flat v-btn--text theme--light v-size--default blue--text text--darken-1"
            @click="deleteMetadata(metadata)"
          >
            <span class="v-btn__content">Valider</span>
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Vue from 'vue'
import config from '../../../../config'

export default {
  name: 'DeleteMetadataDialog',
  props: {
    metadata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    deleteMetadataDialogState: Boolean
  },
  data: () => ({
    successMessage: null,
    loading: false,
    errors: []
  }),
  methods: {
    deleteMetadata (metadata) {
      this.loading = true

      Vue.prototype.$http
        .delete(config.apiUrl + '/api/seo/metadata/' + metadata.id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 204) {
            this.successMessage = 'Les metadonnées ont été supprimées.'
            this.errors = []
            this.closeDeleteMetadataDialog(true)
          }

          this.loading = false
        })
        .catch(e => {
          this.loading = false

          const response = e.response

          if (response && response.status === 400) {
            const data = response.data
            this.errors = data.violations
            this.successMessage = null
          }

          if (response.status === 500) {
            this.errors.push({
              title: 'Une erreur est intervenue lors de la suppression des metadonnées.'
            })
          }
        })
    },
    closeDeleteMetadataDialog (deleteState) {
      this.$emit('closeDeleteMetadataDialog', deleteState)
    }
  }
}
</script>
